// 深色主题配置，参考 index (26).html 的颜色方案
export const darkTheme = {
  token: {
    // 主色
    colorPrimary: '#165DFF',
    colorSuccess: '#52c41a',
    colorWarning: '#FF7D00',
    colorError: '#ff5a5f',
    
    // 背景色
    colorBgContainer: '#121212',
    colorBgElevated: '#1a1a1a',
    colorBgLayout: '#0a0a0a',
    
    // 文字颜色
    colorText: '#F9FAFB',
    colorTextSecondary: '#9CA3AF',
    colorTextTertiary: '#6B7280',
    colorTextQuaternary: '#4B5563',
    // 文字样式
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    fontWeightStrong: 600,
    
    // 边框颜色
    colorBorder: '#1f2937',
    colorBorderSecondary: '#374151',
    
    // 圆角
    borderRadius: 8,
    borderRadiusLG: 12,
    
    // 阴影
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
    boxShadowSecondary: '0 2px 8px rgba(0, 0, 0, 0.2)',
  },
  components: {
    Card: {
      colorBgContainer: '#202227',
      colorBorderSecondary: '#1f2937',
      borderRadiusLG: 12,
    },
    Table: {
      colorBgContainer: '#202227',
      colorFillAlter: 'rgba(255, 255, 255, 0.02)',
      colorBorderSecondary: '#1f2937',
      headerBg: '#1a1a1a',
      headerColor: '#9CA3AF',
      rowHoverBg: 'rgba(22, 93, 255, 0.05)',
      rowSelectedBg: 'rgba(22, 93, 255, 0.1)',
    },
    Select: {
      colorBgContainer: '#0a0a0a',
      colorBorder: '#1f2937',
      colorText: '#F9FAFB',
      optionSelectedBg: 'rgba(22, 93, 255, 0.2)',
      optionActiveBg: 'rgba(22, 93, 255, 0.1)',
    },
    Button: {
      // 主按钮阴影
      primaryShadow: '0 4px 12px rgba(221, 227, 233, 0.3)',
      // 默认按钮样式（用于 secondary/default 类型）
      defaultBg: '#1a1a1a',
      defaultColor: '#F9FAFB',
      defaultBorderColor: '#374151',
      defaultHoverBg: 'rgba(22, 93, 255, 0.1)',
      defaultHoverColor: '#165DFF',
      defaultHoverBorderColor: '#165DFF',
      defaultActiveBg: 'rgba(22, 93, 255, 0.15)',
      defaultActiveBorderColor: '#0d4ed8',
      defaultActiveColor: '#0d4ed8',
      defaultShadow: '0 4px 12px rgba(22, 93, 255, 0.3)',
      // 文字按钮样式
      textHoverBg: 'rgba(22, 93, 255, 0.1)',
      // 圆角
      borderRadius: 8,
      // 按钮高度
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      // 字体粗细
      fontWeight: 500,
      // 内边距
      paddingInline: 16,
      paddingInlineLG: 24,
      paddingInlineSM: 12,
      // 链接按钮颜色
      linkHoverColor: '#3d7bff',
      // 危险按钮
      dangerColor: '#ff5a5f',
      dangerBorderColor: '#ff5a5f',
      dangerShadow: '0 4px 12px rgba(239, 57, 55, 0.3)',
      dangerBg: 'transparent',
    },
    Alert: {
      colorErrorBg: 'rgba(255, 90, 95, 0.1)',
      colorErrorBorder: 'rgba(255, 90, 95, 0.3)',
      colorInfoBg: 'rgba(22, 93, 255, 0.1)',
      colorInfoBorder: 'rgba(22, 93, 255, 0.3)',
    },
    Input: {
      colorBgContainer: '#0a0a0a',
      colorBorder: '#1f2937',
      colorText: '#F9FAFB',
    },
    Modal: {
      contentBg: '#202227',
      headerBg: '#202227',
      titleColor: '#F9FAFB',
      footerBg: '#202227',
      // 遮罩层
      maskBg: 'rgba(0, 0, 0, 0.65)',
      // 边框
      borderRadius: 12,
      borderRadiusLG: 12,
      // 阴影
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
    },
    Drawer: {
      colorBgElevated: '#202227',
      // 遮罩层
      maskBg: 'rgba(0, 0, 0, 0.65)',
      // 标题颜色
      titleColor: '#F9FAFB',
      // 圆角
      borderRadius: 12,
    },
    Tag: {
      // 默认 Tag 样式
      defaultBg: 'rgba(16, 99, 167, 0.1)',
      defaultColor: '#3d7bff',
      // 各种颜色的 Tag 在暗色主题下的样式
      colorFillSecondary: 'rgba(22, 93, 255, 0.15)',
      // 圆角
      borderRadius: 6,
      // 字体
      fontSize: 12,
      lineHeight: 1.5,
      fontWeight: 500,
      // 内边距
      paddingInline: 8,
      // 边框
      borderColor: 'rgba(22, 93, 255, 0.3)',
      // 各种预设颜色的 Tag
      colorFill: 'rgba(22, 93, 255, 0.1)',
      colorFillTertiary: 'rgba(22, 93, 255, 0.05)',
      // 可关闭 Tag 的关闭图标颜色
      closeIconSize: 12,
    },
    Menu: {
      itemBg: 'transparent',
      itemColor: '#9CA3AF',
      itemSelectedBg: '#165dff',
      itemSelectedColor: '#fff',
      itemHoverBg: 'rgba(22, 93, 255, 0.1)',
      itemHoverColor: '#F9FAFB',
      itemActiveBg: 'rgba(22, 93, 255, 0.15)',
      borderRadius: 8,
    },
    Layout: {
      bodyBg: 'transparent',
      headerBg: '#121212',
      siderBg: '#121212',
    },
    Typography: {
      colorText: '#F9FAFB',
      colorTextSecondary: '#9CA3AF',
      colorTextTertiary: '#6B7280',
      colorTextQuaternary: '#4B5563',
      fontWeightStrong: 600,
    },
  },
};

